import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import ProviderEditRoutes from './routes'

const ProviderEdit = () => {
  const { providerId } = useNumericParams()

  useReduxAction(
    'providers',
    'loadProvider',
    {
      entityId: providerId,
      ...defaultRequestOptions.provider,
    },
    [providerId],
    {
      dispatchAction: (action, requestOptions) => action(providerId, requestOptions),
      shouldPerformFn: ({ loading }) => providerId && !loading,
    },
  )

  return (
    <ProviderEditRoutes />
  )
}

export default ProviderEdit
